// DOM measurement helpers for list-row project pill tier selection.
import { TASK_ROW_TITLE_MIN_WIDTH_PX } from '@/components/ui/buildTaskRowTitleTrailingSx';
import { computeTaskRowPillsColBudgetPx } from '@/features/tasks/utils/ui/projectPillDisplayTier';

const CONTENT_COLUMN_GAP_PX = 4;
const METADATA_FLEX_GAP_PX = 4;

/**
 * @param {HTMLElement} measureEl
 */
export function readProjectPillMeasureWidths(measureEl) {
  const fullEl = measureEl.querySelector('[data-project-pill-measure="full"]');
  const abbrevEl = measureEl.querySelector('[data-project-pill-measure="abbrev"]');
  const dotEl = measureEl.querySelector('[data-project-pill-measure="dot"]');
  return {
    full: fullEl?.getBoundingClientRect().width ?? 0,
    abbrev: abbrevEl?.getBoundingClientRect().width ?? 0,
    dot: dotEl?.getBoundingClientRect().width ?? 0,
  };
}

/**
 * @param {HTMLElement} col — pills column element
 */
export function measureTaskRowPillsColBudgetFromCol(col) {
  const contentEl = col.closest('.task-item__content');
  if (!contentEl) return 0;

  const metadata = col.parentElement;
  const durationEl = metadata?.querySelector(
    '[data-testid="task-item__duration-col"]',
  );
  const metadataSiblingWidthsPx = collectMetadataSiblingWidths(
    metadata,
    col,
    durationEl,
  );
  const titleEl = contentEl.querySelector('.task-item__title');

  return computeTaskRowPillsColBudgetPx({
    contentWidthPx: contentEl.getBoundingClientRect().width,
    titleMinWidthPx: TASK_ROW_TITLE_MIN_WIDTH_PX,
    titleScrollWidthPx: titleEl?.scrollWidth ?? 0,
    contentColumnGapPx: CONTENT_COLUMN_GAP_PX,
    durationColWidthPx: durationEl?.getBoundingClientRect().width ?? 0,
    metadataSiblingWidthsPx,
    metadataFlexGapPx: METADATA_FLEX_GAP_PX,
  });
}

/**
 * @param {HTMLElement|null|undefined} metadata
 * @param {HTMLElement} col
 * @param {Element|null|undefined} durationEl
 */
function collectMetadataSiblingWidths(metadata, col, durationEl) {
  if (!metadata) return [];
  const widths = [];
  for (const child of metadata.children) {
    if (child === col || child === durationEl) continue;
    widths.push(child.getBoundingClientRect().width);
  }
  return widths;
}

/**
 * @param {HTMLElement} col
 * @param {import('react').RefObject<HTMLElement|null>} contextPillsRef
 * @param {() => void} onUpdate
 */
export function attachProjectPillTierObservers(col, contextPillsRef, onUpdate) {
  if (typeof ResizeObserver === 'undefined') return undefined;

  const contentEl = col.closest('.task-item__content');
  const ro = new ResizeObserver(onUpdate);
  if (contentEl) ro.observe(contentEl);
  const titleEl = contentEl?.querySelector('.task-item__title');
  if (titleEl) ro.observe(titleEl);
  if (contextPillsRef.current) ro.observe(contextPillsRef.current);
  const durationEl = col.parentElement?.querySelector(
    '[data-testid="task-item__duration-col"]',
  );
  if (durationEl) ro.observe(durationEl);

  return () => ro.disconnect();
}
